import React from 'react';

import SpinnerBlock from '../../../common/SpinnerBlock';
import Editable from '../../../common/Editable';
import Checkbox from '../../../common/Checkbox';
import numeral from 'numeral';
import { getCurrencySymbol } from '../../../../helpers';

import mockImg from '../../../../assets/images/no-image.png';

const MobileTable = (props) => {
  const {
    data,
    creatable,
    bottomCreateButton,
    removable,
    createLabel,
    handleRemoveItem = () => false,
    handleNewItem,
    loading,
    TableWrap,
    currentQuantityInput,
    currentQuantityInputValue,
    handleToggleQuantityInput,
    handleUpdateQuantity,
    setCurrentQuantityInputValue,
    setCurrentQuantityInput,
    allowVariativeBundles,
    isNew,
    handleUpdateOptional,
  } = props;

  return (
    <>
      <SpinnerBlock show={loading} />
      <TableWrap>
        {data &&
          data.items.map((item, i) => (
            <div className="table-row" key={item.variantId}>
              <div className="right">
                <div className="img">
                  {item.images?.[0] ? (
                    <img src={item.images?.[0]?.url} alt="" />
                  ) : (
                    <img src={mockImg} alt="" />
                  )}
                </div>
                <div className="main">
                  <div className="table-item-title">{item.shortName}</div>
                  <div className="table-item-art">Арт.: {item.article}</div>
                  <div className="table-item-id">{item.id}</div>
                  <div className="table-item-id">{`${numeral(item.price).format(
                    '0,0.[00]',
                  )} ${getCurrencySymbol('RUB')}`}</div>
                  <div className="table-item-quantity">
                    Количество:
                    <Editable
                      value={
                        currentQuantityInput === item.variantId
                          ? currentQuantityInputValue
                          : item.quantity
                      }
                      currentInput={currentQuantityInput === item.variantId}
                      toggleInput={() => handleToggleQuantityInput(item)}
                      handleUpdate={() => handleUpdateQuantity(currentQuantityInputValue, i)}
                      onChange={(e) => setCurrentQuantityInputValue(e.target.value)}
                      handleCancel={() => setCurrentQuantityInput(null)}
                    />
                    шт.
                  </div>
                  <div className="table-item-quantity">Остаток: {item.stockAvailable} шт.</div>
                  {allowVariativeBundles && !isNew && (
                    <div className="mt-1">
                      <Checkbox
                        label="Обязательный товар"
                        id={`necessaryItem-${item.variantId}`}
                        checked={!item.optional}
                        onChange={(e) => handleUpdateOptional(e.target.checked, i)}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="left">
                <div className="table-action">
                  {removable ? (
                    <div className="item-remove" onClick={() => handleRemoveItem(data, i)}>
                      <i className="fe-trash-2" />
                    </div>
                  ) : (
                    <div />
                  )}
                </div>
              </div>
            </div>
          ))}
      </TableWrap>
      {creatable && bottomCreateButton ? (
        <div
          style={{ color: '#7e57c2', cursor: 'pointer', marginBottom: '15px', marginTop: '15px' }}
          onClick={handleNewItem}
        >
          {createLabel}
        </div>
      ) : null}
    </>
  );
};

export default MobileTable;
